import { cn } from '@/lib/utils';
import { Search } from 'lucide-react';
import React from 'react';

import { Input } from '@/components/ui/input';

interface SearchBarProps {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    className?: string;
    // Escape hatch for call sites that already sit inside a bordered
    // container (e.g. a popover) and don't want the input's own border
    // doubling up with it.
    inputClassName?: string;
}

export const SearchBar: React.FC<SearchBarProps> = ({
    value,
    onChange,
    placeholder,
    className,
    inputClassName
}) => (
    <div className={cn('relative flex-1 max-w-xs', className)}>
        <Input
            placeholder={placeholder}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            className={cn('pl-9 sm:pl-10 h-9 sm:h-10', inputClassName)}
        />
        <Search className="top-1/2 left-3 absolute w-4 h-4 text-muted-foreground -translate-y-1/2" />
    </div>
);
